// Четирите ъглови маркера на избрания елемент (9×9, бяло с кехлибарен
// контур, на −6px от ъглите) — както в дизайна.
const CORNERS = [
  "-left-1.5 -top-1.5",
  "-right-1.5 -top-1.5",
  "-left-1.5 -bottom-1.5",
  "-right-1.5 -bottom-1.5",
];

const SelectionHandles = () => (
  <>
    {CORNERS.map((corner) => (
      <span
        key={corner}
        className={`pointer-events-none absolute ${corner} h-[9px] w-[9px] rounded-[2px] border-2 border-brand bg-surface`}
      />
    ))}
  </>
);

export default SelectionHandles;
